import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaskTableRoutingModule } from './task-table-routing.module';
import { TaskTableComponent } from './task-table.component';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TaskPopupModule } from '../task-popup/task-popup.module';
import { MatBadgeModule } from '@angular/material/badge';


@NgModule({
  declarations: [
    TaskTableComponent
  ],
  imports: [
    CommonModule,
    TaskTableRoutingModule,
    CustomFlexLayoutModule,
    SharedModule,
    TaskPopupModule,
    MatBadgeModule
  ]
  ,exports:[
    TaskTableComponent
  ]
})
export class TaskTableModule { }
